import api from "@/frontend/api";

export default {
    get: (params, id = null) => api.get('categories' + (id ? '/' + id : ''), params),
}